import type { SetState } from "zustand";

import type { AskPerformYardState } from "../types";

import { initialDocumentModalState } from "../helpers";

export const createDocumentModalSlice = (set: SetState<AskPerformYardState>) => ({
	documentModal: initialDocumentModalState,

	openDocumentModal: (s3FileId: string, filename: string) => {
		set({
			documentModal: {
				isOpen: true,
				document: {
					id: s3FileId,
					_id: s3FileId,
					filename,
					// Minimal required fields - the modal uses id/filename for iframe preview
					clean: true,
					company: "",
					length: 0,
					owner: "",
					tags: [],
					uploader: "",
					uploadedAt: "",
				},
			},
		});
	},
	closeDocumentModal: () => set({ documentModal: initialDocumentModalState }),
});
